export default {
    FORTIVA_STANDARD: "fortiva_standard",
    HFD_STANDARD: "hfd_standard",
    LENDINGCLUB_STANDARD: "lendingclub_standard",
    PROCEED_STANDARD: "proceed_standard",
    SYNCHRONY_STANDARD: "synchrony_standard",
    AFF_STANDARD: "aff_standard",
}
